import React, {useState, useRef} from 'react';
import {Link} from 'react-router-dom';
import emailjs from 'emailjs-com';
import { StyledResa, StyledBtn } from '../styles';
import { getServiceGroups } from '../components/ResaServiceGroups';
import gsap from "gsap";

const start = "M0 0.999512C0 0.999512 60.5 0.999512 150 0.999512C239.5 0.999512 300 0.999512 300 0.999512";
const end = "M1 0.999512C1 0.999512 61.5 7.5 151 7.5C240.5 7.5 301 0.999512 301 0.999512";

function validateEmail(email){
    let re = /\S+@\S+\.\S+/;
    return re.test(email);
};

function validatePhone(phone){
    let re = /^[\+]?[(]?[°0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
    return re.test(phone);
};

function colorize(color, line, placeholder, input){
    gsap.to(line, {stroke : color, duration: .75});
    gsap.to(placeholder, {color: color, duration: .75});
    gsap.to(input, {color: color, duration: .75});
};

const ReservationPageTel = () => {

    // Form animation
    const [genre, setGenre] = useState('');
    const [type, setType] = useState('');
    const [detail, setDetail] = useState('');

    const familyInput = useRef();    const familyLine = useRef();    const familyPlaceholder = useRef();
    const nameInput = useRef();    const nameLine = useRef();    const namePlaceholder = useRef();
    const telInput = useRef();    const telLine = useRef();    const telPlaceholder = useRef();
    const mailInput = useRef();    const mailLine = useRef();    const mailPlaceholder = useRef();

    const handleFocus = (inputRef, lineRef, placeholderRef) => {
        if (!inputRef.current.value) {
            gsap.fromTo(lineRef.current, { attr: { d: start } }, { attr: { d: end }, ease: 'Power2.easeOut', duration: .75 });
            gsap.to(lineRef.current, { attr: { d: start }, ease: 'elastic.out(3, .5)' }, '<50%');
            gsap.to(placeholderRef.current, { top: -15, left: 0, scale: .7, duration: .5, ease: 'Power2.easeOut' }, '<');
        }
    };

    const handleBlur = (inputRef, placeholderRef) => {
        if (!inputRef.current.value) {
        gsap.to(placeholderRef.current, { top: 0, left: 0, scale: 1, duration: .5, ease: "Power2.easeOut" });
        gsap.to(placeholderRef.current, {color: "#777474", duration: .5})
        }
    };

    const handleInput = (e, lineRef, placeholderRef, inputRef) => {
        const {type, value} = e.target;
        if (type === 'text'){
            if (value.length > 2){
                colorize('#6391E8', lineRef.current, placeholderRef.current, inputRef.current);
            } else if (value.length < 1){
                colorize("#D1D4DA", lineRef.current, placeholderRef.current, inputRef.current);
            } else {
                colorize("#FE8C99", lineRef.current, placeholderRef.current, inputRef.current);
            }
        }
        if (type === 'email'){
            if (validateEmail(value)){
                colorize('#6391E8', lineRef.current, placeholderRef.current, inputRef.current);
            } else if (value.length < 1){
                colorize("#D1D4DA", lineRef.current, placeholderRef.current, inputRef.current);
            } else {
                colorize("#FE8C99", lineRef.current, placeholderRef.current, inputRef.current);
            }
        }
        if (type === 'tel'){
            if (validatePhone(value)){
                colorize('#6391E8', lineRef.current, placeholderRef.current, inputRef.current);
            } else if (value.length < 1){
                colorize("#D1D4DA", lineRef.current, placeholderRef.current, inputRef.current);
            } else {
                colorize("#FE8C99", lineRef.current, placeholderRef.current, inputRef.current);
            }
        }
    }

    const [hour, setHour] = useState('');
    const [date, setDate] = useState(() => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    })
    const formatDateToEuropean = (isoDate) => {
        if (!isoDate) return '';
        const [year, month, day] = isoDate.split('-');
        return `${day}/${month}/${year}`;
    };

    // Email handling
    const [name, setName] = useState('');
    const [family, setFamily] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [genreMail, setGenreMail] = useState('');
    const [typeMail, setTypeMail] = useState('');
    const [detailMail, setDetailMail] = useState('');

    const SubmitHandler = async (e) => {
        if (!family || !name || !email || !phone || !genre || !type || !date || !hour){
            alert('Veuillez remplir tous les champs.');
            return;
        }

        const serviceID = 'service_ggk3gbc';
        const templateID = 'template_ln7m1c3';
        const confirmID = 'template_hw5ixaj';
        const publicKey = 'YGdN_Bye0qF3z4Vj4';
        const templateParams= {
            from_name: name,
            from_family: family,
            from_email: email,
            from_phone: phone,
            genre: genreMail,
            type: typeMail,
            detail: detailMail,
            date: formatDateToEuropean(date),
            hour: hour,
        }
        try {
            const res = await emailjs.send(serviceID, templateID, templateParams, publicKey);
            await emailjs.send(serviceID, confirmID, {
                to_name:name,
                to_family: family,
                to_email: email,
                date : formatDateToEuropean(date),
                hour: hour,
                genre: genreMail,
                type: typeMail,
                detail: detailMail,
            }, publicKey)
            setName('');
            setFamily('');
            setEmail('');
            setPhone('');
            setGenre('');
            setType('');
            setDetail('');
            setShowConfirmation(true);
        } catch (error) {
            console.error('Veuillez réessayer plus tard.', error);
        }
    }

    const [showConfirmation, setShowConfirmation] = useState(false);

    return(
        <StyledResa>
            <div className="content">
                <React.Fragment>
                    <div className="txt-left">
                        <h5>Réservation</h5>
                        <p>En raison d'un trop grand nombre de rendez-vous non honorés, les réservations se font désormais uniquement par téléphone au <em>01.47.07.24.90</em> du mardi au samedi de 10h à 19h. </p>
                    </div>
                </React.Fragment>
            </div>
        </StyledResa>
    )
}


export default ReservationPageTel;